import { createHorizontalTimelineSelector } from '../selectors'
import { stageSizeSelector } from './stage_selectors'
import { HorizontalTimelineState } from '../reducers'
import { Dimensions } from '../types/types'

// the position and size of the background
export const backgroundBoundsSelector: (state: HorizontalTimelineState, props: any) => Dimensions =
  createHorizontalTimelineSelector(stageSizeSelector, function (stageSize) {
    return stageSize
  })
